import { ShoppingCartRedirectPopup } from '@setplex/arcana'
import { useUnit } from 'effector-react'
import {
  $isAccountSettingsModalOpened,
  closeAccountSettingsModal,
  getPortalAccountAccessTokenFx,
  navigateToAccountSettings,
} from '../model'
import { $accountSettignsModalTranslations } from './translations'

export const AccountSettingsModal = () => {
  const isOpened = useUnit($isAccountSettingsModalOpened)
  const isLoading = useUnit(getPortalAccountAccessTokenFx.pending)
  const closePopup = useUnit(closeAccountSettingsModal)
  const navigate = useUnit(navigateToAccountSettings)
  const { title, buttonTitle } = useUnit($accountSettignsModalTranslations)

  return (
    <ShoppingCartRedirectPopup
      isOpened={isOpened}
      title={title}
      buttonTitle={isLoading ? '' : buttonTitle}
      isLoading={isLoading}
      onClick={navigate}
      onClosePopup={closePopup}
    />
  )
}
